 <template>
  <div>
    <div v-if="partnerId" id="section-accordion">
      <div class="row">
       
        <div class="col-md-12">
          <div class="accordion mb-6" id="accordionExample">
            <div class="card mb-4">
              <a
                href="#collapseOne"
                class="card-header text-decoration-none collapsed"
                data-toggle="collapse"
                aria-expanded="true"
                aria-controls="collapseOne"
                id="headingOne"
              >
                <span class="card-icon"><i class="fas fa-building"></i></span>
                <span class="card-title mb-0"> Edit Branch </span>
                <span class="dynamic-icon"></span>
              </a>
              <div
                id="collapseOne"
                class="collapse"
                aria-labelledby="headingOne"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <EditMyBusinessLocation
                    v-bind:partner-id="partnerId"
                  ></EditMyBusinessLocation>
                </div>
              </div>
            </div>
            <div class="card mb-4">
              <a
                href="#collapseTwo"
                class="card-header text-decoration-none collapsed"
                id="headingTwo"
                data-toggle="collapse"
                aria-expanded="true"
                aria-controls="collapseTwo"
              >
                <span class="card-icon"><i class="fas fa-location"></i></span>
                <span class="card-title mb-0"> Edit Branch Address </span>
                <span class="dynamic-icon"></span>
              </a>
              <div
                id="collapseTwo"
                class="collapse"
                aria-labelledby="headingTwo"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <EditMyBusinessAddress v-bind:partner-id="partnerId" />
                </div>
              </div>
            </div>
            <div class="card mb-4">
              <a
                href="#collapseThree"
                class="card-header text-decoration-none collapsed"
                id="headingThree"
                data-toggle="collapse"
                aria-expanded="false"
                aria-controls="collapseThree"
              >
                <span class="card-icon"><i class="far fa-images"></i></span>
                <span class="card-title mb-0"> Branch Images </span>
                <span class="dynamic-icon"></span>
              </a>

              <div
                id="collapseThree"
                class="collapse"
                aria-labelledby="headingThree"
                data-parent="#accordionExample"
              >
                <div class="card-body">
                  <UploadMyBusinessImages
                    v-bind:show-done-btn="true"
                    v-bind:partner-id="partnerId"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 <script>
import UploadMyBusinessImages from "../Upload/UploadMyBusinessImages";
import EditMyBusinessLocation from "../MyLocations/EditMyBusinessLocation";
import EditMyBusinessAddress from "../MyBusinessAddress/EditMyBusinessAddress";
export default {
  name: "EditBusinessBranchStepper",
  props: ["partnerId"],
  components: {
    UploadMyBusinessImages,
    EditMyBusinessLocation,
    EditMyBusinessAddress,
  },
  mounted() {},
  methods: {},
};
</script>

